import { createSlice } from "@reduxjs/toolkit";
import { fetchAcceptTerms } from "../../services/selfie";

const initialState = {
  acceptTerms: false,
};

const termsSlice = createSlice({
  name: "terms",
  initialState,
  reducers: {
    setAceptTerms: (state, action) => {
      state.acceptTerms = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchAcceptTerms.fulfilled, (state, action) => {
      state.acceptTerms = action.payload;
    });

    builder.addCase(fetchAcceptTerms.rejected, (state, action) => {
      state.acceptTerms = false;
    });
  },
});

export const { setAceptTerms } = termsSlice.actions;

export default termsSlice.reducer;
